import { render } from "./Intro.vue?vue&type=template&id=2458c317&scoped=true&ts=true"
import script from "./Intro.vue?vue&type=script&lang=ts"
export * from "./Intro.vue?vue&type=script&lang=ts"

import "./Intro.vue?vue&type=style&index=0&id=2458c317&scoped=true&lang=scss"

import exportComponent from "/Users/leonardomarsigli/code/LeoMarseo/personal-projects/dirtysocks-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2458c317"]])

export default __exports__